import { BrowserRouter, Route, Routes } from "react-router-dom";
import { LoginScreen } from "../LoginScreen";
import { PublicRoute } from "./PublicRoute";
import { ProtectedRoute } from "./ProtectedRoute";
import { ZoneRoute } from "./ZoneRoute";
import { Practice } from "../Pages/Practice";
import { Icons } from "../Pages/Icons";
import LayoutDefault from "../Pages/LayoutDefault";
import ControlPanel from "../Pages/ControlPanel";
import VideoWallControlPage from "../Pages/VideoWallControlPage";
import VideoWallDisplay from "../Pages/VideoWallDisplay";
import ZoneA from "../Pages/ZoneA";
import ZoneB from "../Pages/ZoneB";
import ZoneC from "../Pages/ZoneC";
import ZoneX from "../Pages/ZoneX";
import ZoneZ from "../Pages/ZoneZ";

export default function RoutesSwitcher(){
    return(
        <BrowserRouter>
            <Routes>
                <Route element={<PublicRoute/>}>
                    <Route path ="/" element={<LoginScreen/>} />
                </Route>
                <Route element={<ProtectedRoute />}>
                    {/* Zone display endpoints — each guarded by the user's VD tags */}
                    <Route path="/zoneA" element={<ZoneRoute><ZoneA /></ZoneRoute>} />
                    <Route path="/zoneB" element={<ZoneRoute><ZoneB /></ZoneRoute>} />
                    <Route path="/zoneC" element={<ZoneRoute><ZoneC /></ZoneRoute>} />
                    <Route path="/zoneX" element={<ZoneRoute><ZoneX /></ZoneRoute>} />
                    <Route path="/zoneZ" element={<ZoneRoute><ZoneZ /></ZoneRoute>} />
                    
                    {/* Control page — requires VDcontrol or VDadmin tag */}
                    <Route path="/videowallcontrols" element={<ZoneRoute><VideoWallControlPage /></ZoneRoute>} />
                    
                    {/* Legacy routes */}
                    <Route path="/videowall" element={<VideoWallDisplay />} />
                    <Route path="/videowallold" element={<LayoutDefault />} />
                    <Route path="/controls" element={<ControlPanel />} />
                    <Route path="/practice" element={<Practice />} />
                    <Route path="/icons" element={<Icons />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
};